import formatCountryToLanguage from './formatCountryToLanguage'

const allCountries = [
  'GB',
  'DK',
  'FI',
  'FR',
  'DE',
  'IT',
  'LV',
  'RU',
  'ES',
  'SE',
  'TR',
  'CZ',
  'NO',
  'EE',
  'NL',
  'PL',
  'US',
  'SK',
  'SI'
]

const allLanguages = allCountries.map(formatCountryToLanguage)

export default url => {
  if (allLanguages.includes(url.split('/')[1].toLowerCase())) {
    return url.split('/')[1]
  }

  return 'en'
}
